import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/auth.css';

const SubscriptionExpired = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <main className="subscription-expired-page">
      <div className="auth-card subscription-expired-card">
        <div className="auth-header">
          <div className="warning-icon">⚠️</div>
          <h1>Subscription Expired</h1>
          <p>Your subscription is no longer active</p>
        </div>

        <div className="subscription-info">
          <p>Hello <strong>{user?.first_name} {user?.last_name}</strong>,</p>
          <p>Your business <strong>{user?.business_name}</strong> has an inactive subscription.</p>
          
          <div className="status-box">
            <p><strong>Current Status:</strong> {user?.subscription_status}</p>
          </div>

          <p>To continue using Harvyq ERP, please renew your subscription.</p>
        </div>

        <div className="auth-actions">
          <Link to="/settings/subscription/renew" className="auth-button">
            Renew Subscription
          </Link>
          <button type="button" onClick={handleLogout} className="auth-button secondary">
            Logout
          </button>
        </div>

        <div className="auth-footer">
          <p>Need help? <Link to="/support">Contact Support</Link></p>
        </div>
      </div>
    </main>
  );
};

export default SubscriptionExpired;